import { createContext } from 'react'

import { Ability } from './types/ability'

export const AbilityContext = createContext<Ability>({} as Ability)
